/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceSprache as AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache } from '../../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-sprache';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IFinishRegisterUserCommand {
  email?: null | string;
  password?: null | string;
  scope?: null | Array<string>;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
  verificationToken?: null | string;
}
export class FinishRegisterUserCommand extends BaseModel implements IFinishRegisterUserCommand {
  email?: null | string;
  password?: null | string;
  scope?: null | Array<string>;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
  verificationToken?: null | string;
}

